const STORAGE_PREFIX = 'ts_club_';
const PARENT_SESSION_KEY = `${STORAGE_PREFIX}parent_session`;

export interface ParentAuthSession {
  token: string;
  userId: number;
  email: string;
  name: string;
  role: string;
  siteCode: string;
  clubOrgId: number;
  permissionOrgIds: number[];
  childrenCount: number;
  competitionsCount: number;
}

export const storage = {
  setSiteCode(code: string) {
    localStorage.setItem(`${STORAGE_PREFIX}site_code`, code);
  },

  getSiteCode() {
    return localStorage.getItem(`${STORAGE_PREFIX}site_code`);
  },

  clearSiteCode() {
    localStorage.removeItem(`${STORAGE_PREFIX}site_code`);
  },

  setParentAuthSession(session: ParentAuthSession, remember: boolean) {
    const serializedSession = JSON.stringify(session);

    if (remember) {
      localStorage.setItem(PARENT_SESSION_KEY, serializedSession);
      sessionStorage.removeItem(PARENT_SESSION_KEY);
      return;
    }

    sessionStorage.setItem(PARENT_SESSION_KEY, serializedSession);
    localStorage.removeItem(PARENT_SESSION_KEY);
  },

  getParentAuthSession(): ParentAuthSession | null {
    const localSession = localStorage.getItem(PARENT_SESSION_KEY);
    const sessionSession = sessionStorage.getItem(PARENT_SESSION_KEY);
    const serializedSession = sessionSession || localSession;

    if (!serializedSession) return null;

    try {
      return JSON.parse(serializedSession) as ParentAuthSession;
    } catch {
      localStorage.removeItem(PARENT_SESSION_KEY);
      sessionStorage.removeItem(PARENT_SESSION_KEY);
      return null;
    }
  },

  clearParentAuthSession() {
    localStorage.removeItem(PARENT_SESSION_KEY);
    sessionStorage.removeItem(PARENT_SESSION_KEY);
  },
};
